/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Group_SubtitleInputs */

const vi_shop_group_subtitle = /** @type {(inputs: Shop_Group_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nhóm = trang sản phẩm trên web / Mini App; mỗi nhóm gồm nhiều LOẠI (SKU ERP).`)
};

/**

* @param {Shop_Group_SubtitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_subtitle = /** @type {((inputs?: Shop_Group_SubtitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_SubtitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_subtitle(inputs)
});